import $ from 'jquery';

class MaRSCovid {

  constructor() {
    setTimeout(this.LoadActiveResults(), 750);
    this.resultsDiv = $(".covid-ventures__results");
    this.showButton = $(".covid-ventures__link");
    this.loadMoreButton = $(".covid-ventures__load a");
    this.events();
    this.isSpinnerVisible = false;
    this.previousValue;
    this.typingTimer;
    this.loadInfo;
  }

  events() {
    this.showButton.on("click", this.fetchLogic.bind(this));
    this.loadMoreButton.on("click", this.getMoreResults.bind(this));
  }

  fetchLogic(e) {
    if ($(this)) {
      clearTimeout(this.typingTimer);

      let target = e.target;
      target = target.getAttribute('href');
      target = target.substring(1, target.length);

      if (this.showButton) {
        if (!this.isSpinnerVisible) {
          this.resultsDiv.html(`
            <div class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>`);
          this.isSpinnerVisible = true;
        }
        this.typingTimer = setTimeout(this.getResults(target), 750);
        this.loadMoreButton.attr("data-url", `type=${target}&page=2`);

      } else {
        this.resultsDiv.html('');
        this.isSpinnerVisible = false;
      }
    }
  }

  getResults(covidSupportValue) {
    let i = 0;
    $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/covid?type=' + covidSupportValue + '&page=1&hide=1', (results) => {
      let currentPage = results.current_page;

      this.resultsDiv.html(`
            ${results.covidInfo.length ? '<div class="row">' : '<p>No Covid-19 information matches that search.</p>'}
              ${results.covidInfo.map(item => `<div class="col col-12 col-md-6 col-lg-4"><a href="${(item.featured_item === true || item.external_page === true ) ? (item.featured_item_link ? item.featured_item_link : item.external_link) : item.permalink}" ${item.external_page === true ? 'target="_blank"' : ''} 
                class="covid-ventures__card ${item.featured_item === true ? 'covid-ventures__featured' : ''}" data-enter="fade" data-enter-delay="${i=i+50}">
                <h3>${item.title}</h3>
                ${item.description}
                <i class="covid-ventures__arrow"><svg xmlns="http://www.w3.org/2000/svg" width="45" height="10" viewBox="0 0 45 10">
                  <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                      <path d="M1 5h42M40 1l4 4-4 4"/>
                  </g></svg>
                </i>
                ${item.external_page ? '<i class="covid-ventures__external"></i>' : ''}</a></div>`).join('')}
            ${results.covidInfo.length ? '</div>' : ''}
          </div>
       
      `);
      this.isSpinnerVisible = false;
      this.loadMoreButton.attr("data-url", `type=${covidSupportValue}&page=2&hide=1`);
      `${results.max_pages == currentPage || results.max_pages == 0 ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
    }).fail(function(jqXHR, textStatus, error) {
    });
  }


  LoadActiveResults() {
    let covidSupportValue;
    covidSupportValue = $('.covid-ventures__tabsContent .active').attr("id");
    // let activeSelection = $('.covid-ventures__link.active').attr("id").replace("#", "");

    if ($(".covid-ventures__results").length) {
      let i = 0;
      $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/covid?type=' + covidSupportValue + '&page=1&hide=1', (results) => {
        let currentPage = results.current_page;

        this.resultsDiv.html(`
            ${results.covidInfo.length ? '<div class="row">' : '<p>No Covid-19 information matches that search.</p>'}
              ${results.covidInfo.map(item => `<div class="col col-12 col-md-6 col-lg-4"><a href="${(item.featured_item === true || item.external_page === true ) ? (item.featured_item_link ? item.featured_item_link : item.external_link) : item.permalink}" ${item.external_page === true ? 'target="_blank"' : ''} 
                class="covid-ventures__card ${item.featured_item === true ? 'covid-ventures__featured' : ''}" data-enter="fade" data-enter-delay="${i=i+50}">
                <h3>${item.title}</h3>
                ${item.description}
                <i class="covid-ventures__arrow"><svg xmlns="http://www.w3.org/2000/svg" width="45" height="10" viewBox="0 0 45 10">
                  <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                      <path d="M1 5h42M40 1l4 4-4 4"/>
                  </g></svg>
                </i>
                ${item.external_page ? '<i class="covid-ventures__external"></i>' : ''}</a></div>`).join('')}
            ${results.covidInfo.length ? '</div>' : ''}
          </div>
      `);
        this.isSpinnerVisible = false;
        `${results.covidInfo.length ? this.loadMoreButton.show() : this.loadMoreButton.hide()}`;
        this.loadMoreButton.attr("data-url", `type=${covidSupportValue}&page=2&hide=1`);
        `${results.max_pages == currentPage || results.max_pages == 0 ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
      }).fail(function (jqXHR, textStatus, error) {
      });
    }

  }


  getMoreResults(e) {
    e.preventDefault();
    this.loadInfo = this.loadMoreButton.attr("data-url");

    let i = 0;
    let currentType = this.loadInfo.split('=');
    currentType = currentType[1].split('&');

    if (!this.isSpinnerVisible) {
      this.resultsDiv.append(`
            <div class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>`);
      this.isSpinnerVisible = true;
    }

    $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/covid?' + this.loadInfo, (results) => {
      let currentPage = results.current_page;
      this.resultsDiv.append(`
           ${results.covidInfo.length ? '<div class="row">' : '<p>No Covid-19 information matches that search.</p>'}
              ${results.covidInfo.map(item => `<div class="col col-12 col-md-6 col-lg-4"><a href="${(item.featured_item === true || item.external_page === true ) ? (item.featured_item_link ? item.featured_item_link : item.external_link) : item.permalink}" ${item.external_page === true ? 'target="_blank"' : ''} 
                class="covid-ventures__card ${item.featured_item === true ? 'covid-ventures__featured' : ''}" data-enter="fade" data-enter-delay="${i=i+50}">
                <h3>${item.title}</h3>
                ${item.description}
                <i class="covid-ventures__arrow"><svg xmlns="http://www.w3.org/2000/svg" width="45" height="10" viewBox="0 0 45 10">
                  <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                      <path d="M1 5h42M40 1l4 4-4 4"/>
                  </g></svg>
                </i>
                ${item.external_page ? '<i class="covid-ventures__external"></i>' : ''}</a></div>`).join('')}
            ${results.covidInfo.length ? '</div>' : ''}
          </div>
       
      `);
      $('.sk-double-bounce').remove();
      this.isSpinnerVisible = false;
      this.loadMoreButton.attr("data-url", `type=${currentType[0]}&hide=1&page=${parseInt(currentPage) + 1}`);
      `${results.max_pages == currentPage || results.max_pages == 0 ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
    }).fail(function(jqXHR, textStatus, error) {
    });
  }

}

export default MaRSCovid;